import {useNavigate, useParams} from "react-router-dom";
import {FaPlus, FaRegCircleXmark} from "react-icons/fa6";
import {BsTelephoneFill} from "react-icons/bs";
import {FaMapMarkerAlt, FaUsers} from "react-icons/fa";
import {IoMdMail} from "react-icons/io";
import {FaUser} from "react-icons/fa";
import {useEffect, useState} from "react";
import {Input, Pagination, Select} from "antd";
import JobCard from "./components/JobCard";
import {LoadingComponent} from "@/components/ui/LoadingComponent";
import CompanyService from "@/services/CompanyService";
import config from "@/config";
import {Link1Icon} from "@radix-ui/react-icons";
import JobService from "@/services/JobService";

function DetailCompany() {
    const ITEM_PER_PAGE = 7; 

    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [avatar, setAvatar] = useState("");
    const {id} = useParams();
    const [company, setCompany] = useState({});
    const [jobsByCompany, setJobsByCompany] = useState([]);

    const handleNavigate = (id) => {
        setLoading(true);
        navigate(config.routes.job + `/${id}`, {replace: true});
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    function handleChangeAvatar(file) {
        if (file) setAvatar(URL.createObjectURL(file));
    }

    function handleRemoveAvatar() {
        setAvatar("");
    }

    useEffect(() => {
        CompanyService.getCompanyById(id).then((res) => {
            setCompany(res.Data)
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }).catch((err) => {
            console.error(err);
            setLoading(false);
        })
    }, [id]);

    useEffect(() => {
        JobService.getJobByCompany(id, {page: currentPage, pageSize: ITEM_PER_PAGE}).then((res) => {
            setJobsByCompany(res.Data)
        })
    }, [id,currentPage]);

    const totalPage = jobsByCompany.length / ITEM_PER_PAGE;

    const onChangePage = (index) => {
        setCurrentPage(index);
    }

    if (loading) {
        return <LoadingComponent/>;
    }
    return (
        <div className="container xl:container flex flex-col mx-auto p-4 lg:p-8">
            <div className="w-full  rounded-xl shadow-lg overflow-hidden">
                <div className="overflow-hidden w-full aspect-[2/1] md:aspect-[3/1] lg:aspect-[5/1] ">
                    <img
                        className="w-full h-full object-cover"
                        src={`/${company.Banner1}`}
                        alt={company.CompanyName + "background"}
                    />
                </div>
                <div
                    className=" flex flex-col gap-6  lg:flex-row justify-between items-center pt-28 lg:pl-64 lg:pt-8 p-8 relative ">
                    <div
                        className="shadow-lg rounded-full w-48 h-48 overflow-hidden absolute top-0 -translate-y-1/2 left-1/2 -translate-x-1/2 lg:left-10 lg:translate-x-0 flex items-center justify-center bg-white">
                        <img
                            className="w-2/3 h-2/3 object-contain "
                            src={`/${company.Logo}`}
                            alt={company.CompanyName + "logo"}
                        />
                    </div>
                    <div className="flex items-center lg:items-start  flex-col gap-4 w-full md:w-2/3">
                        <p className="text-2xl font-bold line-clamp-2">{company.CompanyName}</p>
                        <div className="flex gap-2 flex-wrap items-center justify-center lg:justify-start ">
                            <div
                                className="flex gap-2 items-center text-secondary border border-secondary  px-5 py-1 rounded-lg font-medium">
                                <FaUsers className="w-4 h-4"/>
                                <p>{company.follow} người theo dõi</p>
                            </div>
                        </div>
                    </div>
                    <button
                        className="px-4 py-3 rounded-xl font-bold flex items-center justify-center gap-2 bg-primary text-white hover:bg-primary-hover">
                        <FaPlus className="w-5 h-5"/> Theo dõi công ty
                    </button>
                </div>
            </div>

            <div className="w-full flex flex-col lg:flex-row gap-6 items-start mt-6 min-h-44">
                <div className="w-full  lg:w-3/4 h-full flex flex-col gap-6">
                    <div className="flex flex-col rounded-xl overflow-hidden shadow-xl border p-6">
                        <div className="w-full text-xl font-bold text-primary uppercase">
                            Giới thiệu công ty
                        </div>
                        <hr className="border-primary my-3"/>
                        <div
                            className="w-full min-h-24 bg-white"
                            dangerouslySetInnerHTML={{__html: company.Description}}
                        ></div>
                    </div>
                    <div className="flex flex-col rounded-xl overflow-hidden shadow-xl border p-6">
                        <div className="w-full text-xl font-bold text-primary uppercase ">
                            Vị trí tuyển dụng
                        </div>
                        <hr className="border-primary my-3"/>
                        <div className="w-full bg-white grid lg:grid-cols-2 grid-cols-1 gap-2">
                            {jobsByCompany.map((job) => (
                                <JobCard key={job.Pk} data={job} handleClick={handleNavigate}/>
                            ))}
                        </div>
                        <div className="w-full flex items-center justify-end mt-3">
                            <Pagination
                                responsive={true}
                                onChange={onChangePage}
                                defaultCurrent={currentPage}
                                total={totalPage}
                                pageSize={ITEM_PER_PAGE}
                                showSizeChanger={false}
                            />
                        </div>
                    </div>
                </div>
                <div className="w-full  lg:w-1/4 sticky top-24">
                    <div className="flex flex-col rounded-xl overflow-hidden shadow-xl border p-6">
                        <div className="w-full text-xl font-bold text-primary ">
                            Thông tin liên hệ
                        </div>
                        <hr className="border-primary my-3"/>
                        <div className="w-full min-h-52 bg-white flex flex-col gap-4">
                            <div className="flex flex-col gap-2">
                                <div className="flex items-center gap-1">
                                    <FaMapMarkerAlt className="w-6 h-6 shrink-0 text-primary "/>
                                    <p className={"font-semibold"}>Địa chỉ công ty</p>
                                </div>
                                <p className="text-stone-800">
                                    {company.Address}
                                </p>
                            </div>
                            <div className="flex flex-col gap-2">
                                <div className="flex items-center gap-1">
                                    <BsTelephoneFill className="w-6 h-6 shrink-0 text-primary "/>
                                    <p className={"font-semibold"}>Số điện thoại</p>
                                </div>
                                <p className="text-stone-800">{company.ContactPhone}</p>
                            </div>
                            <div className="flex flex-col gap-2">
                                <div className="flex items-center gap-1">
                                    <IoMdMail className="w-6 h-6 shrink-0 text-primary "/>
                                    <p className={"font-semibold"}>Email</p>
                                </div>
                                <p className="text-stone-800">{company.ContactEmail}</p>
                            </div>
                            <div className={"flex flex-col gap-2"}>
                                <div className={"flex items-center gap-1"}>
                                    <Link1Icon className={"w-6 h-6 shrink-0 text-primary "}/>
                                    <p className={"font-semibold"}>Website</p>
                                </div>
                                <a className="text-indigo-500 hover:underline hover:text-indigo-800 transition-all" href={`https://${company.ContactWebsite}`}>{company.ContactWebsite}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-full flex flex-col rounded-xl overflow-hidden shadow-xl border p-6 mt-6">
                <div className="w-full text-xl font-bold text-primary uppercase">
                    Nộp hồ sơ ứng tuyển
                </div>
                <hr className="border-primary my-3"/>
                <div className="flex flex-col md:flex-row items-center  md:items-start">
                    <div className="w-2/5 px-4 md:w-1/5 flex flex-col gap-1">
                        <p className="text-sm font-bold">Ảnh hồ sơ</p>
                        <div className="relative">
                            <Input
                                id="avatar"
                                hidden
                                type="file"
                                onChange={(e) => handleChangeAvatar(e.target.files[0])}
                            />
                            <label
                                htmlFor="avatar"
                                className="w-full aspect-square shadow-xl border flex items-center justify-center"
                            >
                                {!avatar && <FaUser className="w-16 h-16"/>}
                                {!!avatar && <img src={avatar} alt="Avatar"/>}
                            </label>
                            {!!avatar && (
                                <FaRegCircleXmark
                                    onClick={handleRemoveAvatar}
                                    className="absolute  w-4 h-4 top-0 right-0 -translate-x-1/2 translate-y-1/2"
                                />
                            )}
                        </div>
                    </div>
                    <div className="w-full px-4 md:w-4/5 lg:grid grid-cols-2">
                        <div className="px-4 flex flex-col gap-1">
                            <p className="text-sm font-bold">
                                Họ Tên <span className="text-red-500">(*)</span>
                            </p>
                            <Input
                                className="h-12 w-full border mb-3 px-4 py-2 "
                                placeholder="VD: Nguyễn Văn A"
                            />
                        </div>
                        <div className="px-4 flex flex-col gap-1">
                            <p className="text-sm font-bold">
                                Ngày sinh <span className="text-red-500">(*)</span>
                            </p>
                            <div className="grid grid-cols-3 gap-6">
                                <div className="h-12 w-full mb-3 rounded-sm">
                                    <Select
                                        // onChange={(e) => console.log(e)}
                                        value={{value: "", label: "Ngày"}}
                                        dropdownRender={(menu) => (
                                            <div>
                                                <div className="p-2 ">
                                                    <Input className="p-2" placeholder="Tìm kiếm"/>
                                                </div>
                                                <div>{menu}</div>
                                            </div>
                                        )}
                                        style={{width: "100%", height: "100%"}}
                                        options={[...new Array(31)].map((_, i) => ({
                                            value: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                            label: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                        }))}
                                        notFoundContent={
                                            <div className="text-red-500 text-center">
                                                Không tìm thấy
                                            </div>
                                        }
                                    />
                                </div>
                                <div className="h-12 w-full mb-3 rounded-sm">
                                    <Select
                                        // onChange={(e) => console.log(e)}
                                        value={{value: "", label: "Tháng"}}
                                        dropdownRender={(menu) => (
                                            <div>
                                                <div className="p-2 ">
                                                    <Input className="p-2" placeholder="Tìm kiếm"/>
                                                </div>
                                                <div>{menu}</div>
                                            </div>
                                        )}
                                        style={{width: "100%", height: "100%"}}
                                        options={[...new Array(12)].map((_, i) => ({
                                            value: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                            label: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                        }))}
                                        notFoundContent={
                                            <div className="text-red-500 text-center">
                                                Không tìm thấy
                                            </div>
                                        }
                                    />
                                </div>
                                <div className="h-12 w-full mb-3 rounded-sm">
                                    <Select
                                        // onChange={(e) => console.log(e)}
                                        value={{value: "", label: "Năm"}}
                                        dropdownRender={(menu) => (
                                            <div>
                                                <div className="p-2 ">
                                                    <Input className="p-2" placeholder="Tìm kiếm"/>
                                                </div>
                                                <div>{menu}</div>
                                            </div>
                                        )}
                                        style={{width: "100%", height: "100%"}}
                                        options={[...new Array(76)].map((_, i) => ({
                                            value: (i + 1950).toString(),
                                            label: (i + 1950).toString(),
                                        }))}
                                        notFoundContent={
                                            <div className="text-red-500 text-center">
                                                Không tìm thấy
                                            </div>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="px-4 flex flex-col gap-1">
                            <p className="text-sm font-bold">
                                Điện thoại <span className="text-red-500">(*)</span>
                            </p>
                            <Input
                                className="h-12 w-full border mb-3 px-4 py-2 "
                                placeholder="VD: 0905123456"
                            />
                        </div>
                        <div className="px-4 flex flex-col gap-1">
                            <p className="text-sm font-bold">Email</p>
                            <Input
                                className="h-12 w-full border mb-3 px-4 py-2 "
                                placeholder="VD: 0905123456"
                            />
                        </div>
                        <div className="px-4 flex flex-col gap-1">
                            <p className="text-sm font-bold">
                                CCCD/CMND <span className="text-red-500">(*)</span>
                            </p>
                            <Input
                                className="h-12 w-full border mb-3 px-4 py-2 "
                                placeholder="Nhập CCCD/CMND"
                            />
                        </div>
                        <div className="px-4 flex flex-col gap-1">
                            <p className="text-sm font-bold">
                                Nơi cấp <span className="text-red-500">(*)</span>
                            </p>
                            <div className="grid grid-cols-2 gap-6">
                                <div className="h-12 w-full mb-3 rounded-sm">
                                    <Select
                                        value={{value: "", label: "Nơi cấp CCCD/CMND"}}
                                        dropdownRender={(menu) => (
                                            <div>
                                                <div className="p-2 ">
                                                    <Input className="p-2" placeholder="Tìm kiếm"/>
                                                </div>
                                                <div>{menu}</div>
                                            </div>
                                        )}
                                        style={{width: "100%", height: "100%"}}
                                        options={[...new Array(31)].map((_, i) => ({
                                            value: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                            label: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                        }))}
                                        notFoundContent={
                                            <div className="text-red-500 text-center">
                                                Không tìm thấy
                                            </div>
                                        }
                                    />
                                </div>
                                <div className="h-12 w-full mb-3 rounded-sm">
                                    <Input
                                        className=" h-12 w-full border mb-3 px-4 py-2"
                                        type="date"
                                        placeholder="Nhập CCCD/CMND"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-span-2 px-4 flex flex-col gap-1">
                            <p className="text-sm font-bold">
                                Địa chỉ liên hệ <span className="text-red-500">(*)</span>
                            </p>
                            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 gap-y-0">
                                <div className="h-12 w-full mb-3 rounded-sm">
                                    <Select
                                        value={{value: "", label: "Chọn tỉnh thành"}}
                                        dropdownRender={(menu) => (
                                            <div>
                                                <div className="p-2 ">
                                                    <Input className="p-2" placeholder="Tìm kiếm"/>
                                                </div>
                                                <div>{menu}</div>
                                            </div>
                                        )}
                                        style={{width: "100%", height: "100%"}}
                                        options={[...new Array(31)].map((_, i) => ({
                                            value: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                            label: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                        }))}
                                        notFoundContent={
                                            <div className="text-red-500 text-center">
                                                Không tìm thấy
                                            </div>
                                        }
                                    />
                                </div>
                                <div className="h-12 w-full mb-3 rounded-sm">
                                    <Select
                                        value={{value: "", label: "Chọn quận/huyện"}}
                                        dropdownRender={(menu) => (
                                            <div>
                                                <div className="p-2 ">
                                                    <Input className="p-2" placeholder="Tìm kiếm"/>
                                                </div>
                                                <div>{menu}</div>
                                            </div>
                                        )}
                                        style={{width: "100%", height: "100%"}}
                                        options={[...new Array(31)].map((_, i) => ({
                                            value: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                            label: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                        }))}
                                        notFoundContent={
                                            <div className="text-red-500 text-center">
                                                Không tìm thấy
                                            </div>
                                        }
                                    />
                                </div>
                                <div className="h-12 w-full mb-3 rounded-sm">
                                    <Select
                                        value={{value: "", label: "Chọn xã/phường"}}
                                        dropdownRender={(menu) => (
                                            <div>
                                                <div className="p-2 ">
                                                    <Input className="p-2" placeholder="Tìm kiếm"/>
                                                </div>
                                                <div>{menu}</div>
                                            </div>
                                        )}
                                        style={{width: "100%", height: "100%"}}
                                        options={[...new Array(31)].map((_, i) => ({
                                            value: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                            label: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                        }))}
                                        notFoundContent={
                                            <div className="text-red-500 text-center">
                                                Không tìm thấy
                                            </div>
                                        }
                                    />
                                </div>
                                <Input
                                    className="h-12 w-full border mb-3 px-4 py-2 "
                                    placeholder="Nhập số nhà - khu phố"
                                />
                            </div>
                        </div>
                        <div className="px-4 flex flex-col gap-1">
                            <p className="text-sm font-bold">
                                Công việc ứng tuyển <span className="text-red-500">(*)</span>
                            </p>
                            <div className="h-12 w-full mb-3 rounded-sm">
                                <Select
                                    value={{value: "", label: "Chọn công việc ứng tuyển"}}
                                    dropdownRender={(menu) => (
                                        <div>
                                            <div className="p-2 ">
                                                <Input className="p-2" placeholder="Tìm kiếm"/>
                                            </div>
                                            <div>{menu}</div>
                                        </div>
                                    )}
                                    style={{width: "100%", height: "100%"}}
                                    options={[...new Array(31)].map((_, i) => ({
                                        value: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                        label: i < 9 ? "0" + (i + 1) : (i + 1).toString(),
                                    }))}
                                    notFoundContent={
                                        <div className="text-red-500 text-center">
                                            Không tìm thấy
                                        </div>
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-span-2 px-4">
                            <input type="checkbox" className="mr-1 w-3 h-3"/>
                            Tôi đồng ý với quy định và thỏa thuận sử dụng của
                            Vieclamsanxuat.com, đồng ý cung cấp và cho phép xử lý dữ liệu cá
                            nhân cho mục đích tìm kiếm việc làm
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        className=" p-2 border min-w-80 text-base text-white bg-primary rounded-sm uppercase font-bold ">
                        Đăng nhập để nộp hồ sơ
                    </button>
                </div>
            </div>
        </div>
    );
}

export default DetailCompany;
